import ContentContainer from "@/components/content-container";
import { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./YourInfoForm.module.scss";
import Input from "@/components/input";
import usePickupStore from "@/stores/pickup";

interface YourInfoFormProps {
  className: string;
}

const YourInfoForm: FC<YourInfoFormProps> = ({ className }) => {
  const { t } = useTranslation();
  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    phoneNumber,
    setPhoneNumber,
    emailAddress,
    setEmailAddress,
    formFieldErrors: errors,
  } = usePickupStore();

  const getOnChange = (setter: (value: string) => void) => {
    return (event: ChangeEvent<HTMLInputElement>) => setter(event.target.value);
  };

  return (
    <ContentContainer title={t("pickup.yourInfoPage.yourInfo")} className={className}>
      <div className={styles.content}>
        <h5 className={styles.subtitle}>{t("pickup.yourInfoPage.personalInfo")}</h5>
        <form className={styles.form}>
          <div className={styles.nameRow}>
            <Input
              className={styles.input}
              large={false}
              label={t("pickup.yourInfoPage.firstName")}
              hideRemoveButton
              value={firstName}
              onChange={getOnChange(setFirstName)}
              error={errors.firstName ? t("pickup.yourInfoPage.errors.firstName") : undefined}
              data-cy="first-name-input"
            />
            <Input
              className={styles.input}
              large={false}
              label={t("pickup.yourInfoPage.lastName")}
              hideRemoveButton
              value={lastName}
              onChange={getOnChange(setLastName)}
              data-cy="last-name-input"
              error={errors.lastName ? t("pickup.yourInfoPage.errors.lastName") : undefined}
            />
          </div>
          <div>
            <Input
              className={styles.input}
              large={false}
              label={t("pickup.yourInfoPage.emailAddress")}
              hideRemoveButton
              value={emailAddress}
              onChange={getOnChange(setEmailAddress)}
              data-cy="email-address-input"
              error={errors.emailAddress ? t("pickup.yourInfoPage.errors.emailAddress") : undefined}
            />
            <span className={styles.helperText}>{t("pickup.yourInfoPage.emailDesc")}</span>
          </div>
          <div>
            <Input
              className={styles.input}
              large={false}
              label={t("pickup.yourInfoPage.phoneNumber")}
              hideRemoveButton
              value={phoneNumber}
              onChange={getOnChange(setPhoneNumber)}
              data-cy="phone-number-input"
              error={errors.phoneNumber ? t("pickup.yourInfoPage.errors.phoneNumber") : undefined}
            />
            <span className={styles.helperText}>{t("pickup.yourInfoPage.phoneNumberDesc")}</span>
          </div>
        </form>
      </div>
    </ContentContainer>
  );
};

export default YourInfoForm;
